import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-black py-20">
      <div className="max-w-[1400px] mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16">
          <div>
            <Link to="/" className="cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/d593a46d3e3bab12cc8840a0c4cfa5e1/909708bcd66fbf3c051c3980f5af40e8.png" 
                alt="Doohnuts Logo" 
                className="h-[48px] w-auto object-contain"
              />
            </Link>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Quick Links</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                Home
              </Link>
              <Link to="/simulator" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                Simulator
              </Link>
              <Link to="/partnership" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                Partnership
              </Link>
              <Link to="/advertise" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                Advertise
              </Link>
              <Link to="/locations" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                Locations
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Contact</h4>
            <div className="flex flex-col gap-2">
              <a href="mailto:info@doohnutsinc.com" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                info@doohnutsinc.com
              </a>
              <a href="tel:+17025551234" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
                +1 (702) 477-9870
              </a>
              <p className="text-white/60 text-xs">
                101 Convention Center Dr.<br />
                Suite 900<br />
                Las Vegas, NV 89109<br />
                United States
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/60 text-xs">
            ©︎2026 DOOHNUTS Inc. All rights reserved.
          </p>
          <div className="flex gap-6">
            <Link to="/privacy" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
              Privacy Policy
            </Link>
            <Link to="/terms" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
              Terms of Service
            </Link>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors text-xs cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>

        <p className="text-white/40 text-[11px] text-center mt-6 leading-relaxed">
          ※本サイトに掲載されている画像はAIにより生成されたイメージであり、実在の施設・企業・団体との提携や関係を示すものではありません。
        </p>
      </div>
    </footer>
  );
}
